import * as React from 'react';

import {ChatPreview} from 'shells/chat/chat-preview';
import {Body} from 'shells/typography/body';

import type {GetChatSettings_chatSettings_lookAndFeel as LookAndFeelOptions} from 'nutshell-graphql-types';

import {getChatWidgetIcon} from '../helpers';

import styles from '../settings.module.css';

type Props = {
    isOfflineFormEnabled: boolean;
    message: string;
    lookAndFeel: LookAndFeelOptions;
    isConversational: boolean;
};

export function OfflinePreview(props: Props) {
    return (
        <div className='flex flex-dir-col justify-center full-height border br-3 align-center overflow-auto pad-16'>
            <div style={{opacity: props.isOfflineFormEnabled ? 1 : 0.5}}>
                {props.isConversational ? (
                    <ChatPreview
                        headerTitle={props.lookAndFeel.nameDisplay}
                        icon={getChatWidgetIcon(
                            props.lookAndFeel.icon.type,
                            props.lookAndFeel.icon.url
                        )}
                        backgroundColor={props.lookAndFeel.color}
                        status='form'
                        selectedFields={['name']}
                        automatedMessage={props.message}
                        hasEnabledConversationalForms={true}
                        isOnline={false}
                        showPoweredBy={props.lookAndFeel.showPoweredBy}
                        showDisclaimer={props.lookAndFeel.disclaimerSettings.isEnabled}
                        disclaimerText={props.lookAndFeel.disclaimerSettings.message}
                    />
                ) : (
                    <ChatPreview
                        headerTitle={props.lookAndFeel.nameDisplay}
                        icon={getChatWidgetIcon(
                            props.lookAndFeel.icon.type,
                            props.lookAndFeel.icon.url
                        )}
                        backgroundColor={props.lookAndFeel.color}
                        status='offline'
                        offlineMessage={props.message}
                        showPoweredBy={props.lookAndFeel.showPoweredBy}
                        showDisclaimer={props.lookAndFeel.disclaimerSettings.isEnabled}
                        disclaimerText={props.lookAndFeel.disclaimerSettings.message}
                    />
                )}
            </div>
            {!props.isOfflineFormEnabled && !NutClientConfig.hasNudgesForChat && (
                <div className={styles['disabled-container']}>
                    <Body color='white'>You’ve disabled “offline” mode.</Body>
                    <Body color='white'>
                        When agents are offline, the widget will never be shown
                    </Body>
                </div>
            )}
        </div>
    );
}
